import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.customerCancelPage.setFetching(isFetching)

const fetch = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.userOrders + `/${tool}`)
    .then(({ data }) => data)
    .then(({ orders }) => reducers.marketplace.customerCancelPage.setOrders(orders))
}

const cancelOrder = (orderId) => {
  return request.post(constants.marketplace.userCancelOrder + `/${orderId}`, {})
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const fetchOrderPartial = (orderId) => {
  return request.get(constants.marketplace.userCancelOrderPartial + `/${orderId}`)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const fetchOrderPartialTotal = ({ orderId, orders }) => {
  return request.post(constants.marketplace.userCancelOrderPartial + `/${orderId}/total`, orders)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const cancelOrderPartial = ({ orderId, orders }) => {
  return request.post(constants.marketplace.userCancelOrderPartial + `/${orderId}`, orders)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  fetch,
  cancelOrder,
  fetchOrderPartial,
  fetchOrderPartialTotal,
  cancelOrderPartial,
}
